document.addEventListener('DOMContentLoaded', function () {
	// Add click event to all tab link elements
	document.querySelectorAll('.tab-link').forEach(function (tab) {
		tab.addEventListener('click', function () {
			const tabId = this.getAttribute('data-tab'); 
			const parent = this.closest('.tab-link-container').parentElement; 
			parent.querySelectorAll('.tab-link').forEach(el => el.classList.remove('active'));
			parent.querySelectorAll('.tab-content').forEach(el => el.classList.remove('active'));

			const targetTab = parent.querySelector('#' + tabId);
			if (targetTab) {
				targetTab.classList.add('active');
			}

			this.classList.add('active');

			const event = new CustomEvent('tab-changed');
			this.dispatchEvent(event);
		});
	});
});